import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Groups } from '@sm360/widget-commons-forms';

const IndentitySection = ({ contactValue, hasBeenSubmit, handleFormGroupChange }) => {
    return (
        <section>
            <label className="sr-text is-bold">{LocaleService.t('DEPOSIT.PERSONAL_INFOS_SECTION_TITLE')}</label>
            <Groups.IdentityGroup
                values={contactValue}
                labels={{
                    firstname: LocaleService.t('COMMONS_FORMS.CONTACT.FIRSTNAME'),
                    lastname: LocaleService.t('COMMONS_FORMS.CONTACT.LASTNAME'),
                    phoneNumber: LocaleService.t('COMMONS_FORMS.CONTACT.PHONE_NUMBER'),
                    email: LocaleService.t('COMMONS_FORMS.CONTACT.EMAIL'),
                }}
                hasBeenSubmit={hasBeenSubmit}
                onChange={handleFormGroupChange}
            />
        </section>
    );
};

IndentitySection.propTypes = {
    contactValue: PropTypes.string.isRequired,
    hasBeenSubmit: PropTypes.bool.isRequired,
    handleFormGroupChange: PropTypes.func.isRequired,
};

IndentitySection.displayName = 'IndentitySection';

export default IndentitySection;



// WEBPACK FOOTER //
// ./src/components/IndentitySection/IndentitySection.jsx